module.exports = __webpack_public_path__ + "img/Businessman-Transparent.11164ec2.png";